import React, { useEffect, useState } from "react";
import {
    Nav,
    Container,

} from "react-bootstrap";
import { Switch, Route, useRouteMatch, useHistory } from "react-router-dom";
import CustomNavbar from "../../components/CustomNavbar";
import SidebarDashboard from "../../components/SidebarDashboard";
import PlanCarreraIndividual from "./PlanCarreraIndividual";
import PerfilColaborador from "./PerfilColaborador";

import { useDispatch, useSelector } from 'react-redux';

const MenuPlanCarrera = (props) => {
    // State
    const [show, setShow] = useState(false);
    const { location } = props;
    let { path, url } = useRouteMatch();
    const history = useHistory();
    const dispatch = useDispatch();


    // Method
    const onShowSidebar = () => setShow(show ? false : true);

    return (
        <>
            <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
            <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
            <div className="custom-wrapper">
                <Container fluid>
                    

                    <div className="mt-4">
                        <Nav variant="pills" activeKey={location.pathname}>
                            <Nav.Item>
                                <Nav.Link
                                    eventKey={url}
                                    onClick={() => history.push(`${url}`)}
                                >
                                    Plan de Carrera Individual
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link
                                    eventKey={`${url}/perfil-del-colaborador`}
                                    onClick={() => history.push(`${url}/perfil-del-colaborador`)}
                                >
                                    Perfil del Colaborador
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </div>

                    <Switch>
                        <Route path={`${path}`} exact component={PlanCarreraIndividual} />
                        <Route path={`${path}/perfil-del-colaborador`} exact component={PerfilColaborador} />


                    </Switch>
                </Container>

            </div>
        </>
    );
};

export default MenuPlanCarrera;
